import { format } from 'date-fns';
import { TFunction } from 'i18next';

export const formatDateTime = (date: Date): string => {
  return format(date, 'MMM d, h:mma');
};

export const formatDate = (date: Date): string => {
  return format(date, 'MMM d, yyyy, h:mma');
};

type OptionsProps = {
  publishedDate?: Date;
  updatedTime?: Date;
  periods?: string;
  releasedDate?: Date;
  isPreview?: boolean;
  t?: TFunction;
};

export const constructMetadataSentence = (options: OptionsProps): string => {
  const { publishedDate, updatedTime, periods, releasedDate, isPreview, t } =
    options;

  if (!t) {
    return '';
  }

  const parts: string[] = [];

  if (publishedDate) {
    parts.push(
      t('earningsInsight.metadata.publishedWithDate', {
        date: formatDateTime(publishedDate),
      })
    );
  }

  if (isPreview) {
    return parts.join(' · ');
  }

  if (updatedTime) {
    parts.push(
      t('earningsInsight.metadata.updatedWithDate', {
        date: formatDateTime(updatedTime),
      })
    );
  }

  if (periods && releasedDate) {
    parts.push(
      t('earningsInsight.metadata.basedOnEarnings', {
        periods,
        releasedDate: formatDate(releasedDate),
      })
    );
  }

  return parts.join(' · ');
};
